const clipTextBase = ({
    ctx,
    content,
    line,
    ellipsis,
    prefixWidth,
    addonWidth,
    wrapWidth,
    fontStyle,
    fontVariant,
    fontWeight,
    fontSize,
    lineHeight,
    fontFamily,
    emoji,
    emojiWidth,
}) => {
    // 设置canvas上下文的字体
    ctx.font = `${fontStyle} ${fontVariant} ${fontWeight} ${fontSize}/${lineHeight} ${fontFamily}`;

    // 字符分组（主要目的是分出凤凰表情）
    const charList = [];

    let charIndex = 0;

    while (charIndex < content.length) {
        const currentChar = content[charIndex];

        if (currentChar === '[') {
            let tempIndex = charIndex + 1;
            let hasRightPair = false;

            while (tempIndex < content.length) {
                if (content[tempIndex] === ']') {
                    hasRightPair = true;
                    tempIndex += 1;

                    break;
                } else {
                    tempIndex += 1;
                }
            }

            const tempEmoji = content.slice(charIndex, tempIndex);

            if (hasRightPair && emoji.find(item => item.code === tempEmoji)) {
                charList.push(tempEmoji);

                charIndex = tempIndex;
            } else {
                charList.push(currentChar);
                charIndex += 1;
            }
        } else {
            charList.push(currentChar);
            charIndex += 1;
        }
    }

    // 分词
    const wordList = [];

    for (let i = 0; i < charList.length; i++) {
        const prev = charList[i - 1];
        const current = charList[i];

        const postPunctuation = /[!),.:;?\]}¨·ˇˉ―‖’”…∶、。〃々〉》」』】〕〗！＂＇），．：；？］｀｜｝～￠]/;
        const leadingPunctuation = /[([{·‘“〈《「『【〔〖（．［｛￡￥]/;
        const westernLanguage = /[A-Za-z\d]/;

        if (current.length <= 1) {
            if (prev && prev.length <= 1) {
                if (
                    postPunctuation.test(current) ||
                    leadingPunctuation.test(prev) ||
                    current === ' ' ||
                    (westernLanguage.test(prev) && westernLanguage.test(current))
                ) {
                    wordList[wordList.length - 1].text += current;
                } else {
                    wordList.push({ type: 'word', text: current });
                }
            } else {
                wordList.push({ type: 'word', text: current });
            }
        } else {
            wordList.push({ type: 'emoji', text: current });
        }
    }

    const lineList = [];
    let wordIndex = 0;
    let overflow = true;

    for (let i = 0; i < line; i++) {
        const currentWordList = [];
        const isFirstLine = i === 0;
        const isLastLine = i >= line - 1;
        const endLineWord = isLastLine ? ellipsis : '';
        let startLineWidth = 0;

        if (isFirstLine) {
            startLineWidth = prefixWidth;
        } else if (isLastLine) {
            startLineWidth = addonWidth;
        }

        for (let i = wordIndex; i < wordList.length; i++) {
            const currentWord = wordList[wordIndex];

            if (currentWord.text === '\n') {
                currentWordList.push(currentWord);
                wordIndex += 1;

                break;
            }

            const currentTextList = [];
            let currentEmojiWidth = 0;

            [...currentWordList, currentWord].forEach(item => {
                const { type, text } = item;

                if (type === 'word') {
                    currentTextList.push(text);
                } else if (type === 'emoji') {
                    currentEmojiWidth += emojiWidth;
                }
            });

            const currentStr = currentTextList.join('') + endLineWord;
            const currentWidth = startLineWidth + ctx.measureText(currentStr).width + currentEmojiWidth;

            if (currentWidth <= wrapWidth) {
                currentWordList.push(currentWord);
                wordIndex += 1;
            } else {
                break;
            }
        }

        if (isLastLine) {
            currentWordList.push({ type: 'word', text: ellipsis });
        }

        lineList.push(currentWordList.map(item => item.text).join(''));

        if (wordIndex >= wordList.length) {
            overflow = false;

            break;
        }
    }

    const finalText = overflow ? lineList.join('') : content;

    return { text: finalText, overflow, line: lineList.length };
};

export default clipTextBase;
